import React from 'react';

const ActionsMenuButton = ({ label, expanded, onClick, className = '' }) => (
  <button
    type="button"
    onClick={onClick}
    className={`inline-flex items-center justify-center w-8 h-8 rounded-lg text-gray-500 hover:bg-gray-100 hover:text-gray-900 transition-colors ${className}`}
    aria-label={label}
    aria-expanded={expanded}
  >
    <svg className="w-4 h-4" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
      <circle cx="8" cy="2.5" r="1.5" />
      <circle cx="8" cy="8" r="1.5" />
      <circle cx="8" cy="13.5" r="1.5" />
    </svg>
  </button>
);

export default ActionsMenuButton;
